import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import VueCookies from 'vue-cookies'
import { useAuth } from '@/composables/useAuth'
import { useTemplateApp } from '@/composables/useTemplateApp'
import {
  writeRouteCookie,
  type RouteCookieStore
} from '@/utils/yagiprime/routeCookie'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderSpMenu',
  props: {
    isYagiPrime: { type: Boolean, default: false },
    isYagiPrimeCancel: { type: Boolean, default: false }
  },
  setup(__props: any) {



const { user, isAuthenticated } = useAuth()
const { open: openTemplateApp } = useTemplateApp()

// 遷移（href）はそのまま。遷移前に加入導線だけ記録する
const recordPrimeRoute = (): void => {
  writeRouteCookie(VueCookies as unknown as RouteCookieStore, 'header-sp-menu')
}

const userEmail = computed(() => user.value?.email ?? '')

/** 移設元 App.vue の getName 相当 */
const userName = computed(() => {
  const displayName = user.value?.displayName
  if (displayName) return displayName
  const email = userEmail.value
  return email ? email.split('@')[0] : 'ヤギ'
})

/**
 * ヤギディ診断結果。移設元でも値を入れる経路が無く常に null のため、
 * 「あなたのヤギは？」導線だけが出る（挙動そのまま）。
 */
const digramResult = ref<{
  detail_value: { catch_copy_title: string }
} | null>(null)

return { __sfc: true,user, isAuthenticated, openTemplateApp, recordPrimeRoute, userEmail, userName, digramResult }
}

})